import Vuex from 'vuex';
import vClickOutside from 'click-outside-vue3';
import Mapbox from 'mapbox-gl';
import VueMapbox from 'vue-mapbox/dist/vue-mapbox.umd';

import DatalasCharts from '@datalas/charts';
import API from './lib/apiPlugin';

// Components to expose publicly, as part of the library.

import AtlasEmbeddedView from './components/embedded-view/index.vue';

import Widget from './components/widget/widget.vue';
import WidgetV2 from './components/widget/widget-v2.vue';
import Indicator from './components/widget/indicator.vue';
import IndicatorControls from './components/widget/indicator-controls.vue';
import SummaryHeader from './components/data-summary/summary-header.vue';
import AtlasWidgetMain from './components/widget/main.vue';
import AtlasGeoControls from './components/widget/geo-controls.vue';
import AtlasGeoControlsStandalone from './components/geo-controls-standalone/geo-controls-standalone.vue';
import AtlasIndicatorSummary from './components/indicator-summary/index.vue';
import AtlasIndicatorSummaryStandalone from './components/indicator-summary/standalone.vue';
import AtlasIndicatorGroupStandalone from './components/indicator-group/standalone.vue';

// Commonly-used/global/generic components
import Params from './components/widget/params.vue';
import Footer from './components/generic/footer.vue';
import Icon from './components/generic/icon.vue';
import Spinner from './components/generic/spinner.vue';
import Loader from './components/generic/loader.vue';
import Alert from './components/generic/alert.vue';
import ErrorPage from './components/generic/error-page.vue';

export default {
  install: (Vue, options = {}) => {
    const { api: apiOptions } = options;
    Vue.use(Vuex)
      .use(API, apiOptions)
      .use(vClickOutside)
      .use(VueMapbox, { mapboxgl: Mapbox })
      .use(DatalasCharts);

    Vue.component(AtlasEmbeddedView.name, AtlasEmbeddedView);

    Vue.component(Widget.name, Widget);
    Vue.component(WidgetV2.name, WidgetV2);

    Vue.component(Indicator.name, Indicator);
    Vue.component(IndicatorControls.name, IndicatorControls);

    Vue.component(AtlasIndicatorSummary.name, AtlasIndicatorSummary);
    Vue.component(
      AtlasIndicatorSummaryStandalone.name,
      AtlasIndicatorSummaryStandalone,
    );
    Vue.component(
      AtlasIndicatorGroupStandalone.name,
      AtlasIndicatorGroupStandalone,
    );
    Vue.component(SummaryHeader.name, SummaryHeader);
    Vue.component(AtlasGeoControlsStandalone.name, AtlasGeoControlsStandalone);

    Vue.component(AtlasWidgetMain.name, AtlasWidgetMain);
    Vue.component(AtlasGeoControls.name, AtlasGeoControls);
    Vue.component(Params.name, Params);
    Vue.component(Footer.name, Footer);
    Vue.component(Icon.name, Icon);
    Vue.component(Spinner.name, Spinner);
    Vue.component(Loader.name, Loader);
    Vue.component(Alert.name, Alert);
    Vue.component(ErrorPage.name, ErrorPage);
  },
};
